import React from "react";
import styled from "styled-components";

// Styleds
const Description = styled.span`
  margin: 0 0 30px;
  display: block;
  color: #909293;
  font-size: 14px;
`;

export function SectionDescription({ children = "" }: { children?: string }) {
  return <Description>{children}</Description>;
}
